import React from "react";
import { AVAILABLE_MENU_LANGS } from "../i18n/languages.js";

const COUNTRY_NAMES = {
  de: "Deutschland",
  en: "United Kingdom",
  uk: "Україна",
  fr: "France",
  nl: "Nederland",
  pl: "Polska",
  it: "Italia",
  da: "Danmark",
  es: "España",
  no: "Norge",
};

const COUNTRY_ORDER = ["de", "en", "uk", "fr", "nl", "pl", "it", "da", "es", "no"];

export default function CountryBanner({
  reverse = false,
  ariaLabel = "Countries and languages",
}) {
  const baseItems = COUNTRY_ORDER
    .map((code) =>
      AVAILABLE_MENU_LANGS.find(
        (item) => item.code === code || item.value === code
      )
    )
    .filter(Boolean);

  const items = [...baseItems, ...baseItems, ...baseItems];

  return (
    <section
      className={`countryBanner ${reverse ? "countryBanner--reverse" : ""}`}
      aria-label={ariaLabel}
    >
      <div className="countryBanner__inner">
        <div className="countryBanner__viewport">
          <div className="countryBanner__track">
            {items.map((item, index) => {
              const code = item.code || item.value;

              return (
                <div className="countryBanner__item" key={`${code}-${index}`}>
                  <div className="countryBanner__flag" aria-hidden="true">
                    <img
                      className="countryBanner__flagImg"
                      src={item.flag}
                      alt=""
                      loading="lazy"
                      draggable="false"
                    />
                  </div>

                  <div className="countryBanner__name">
                    {COUNTRY_NAMES[code] || item.label}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}